/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Add_Products_And_ServicesInputs */

const en_admin_resource_form_add_products_and_services = /** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Products & Services »`)
};

const de_admin_resource_form_add_products_and_services = /** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte & Services hinzufügen »`)
};

const es_admin_resource_form_add_products_and_services = /** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir Productos & Servicios »`)
};

const fr_admin_resource_form_add_products_and_services = /** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des Produits & Services »`)
};

/** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */
const it_admin_resource_form_add_products_and_services = en_admin_resource_form_add_products_and_services;

/** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_add_products_and_services = en_admin_resource_form_add_products_and_services;

/** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */
const pl_admin_resource_form_add_products_and_services = en_admin_resource_form_add_products_and_services;

/** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */
const hu_admin_resource_form_add_products_and_services = en_admin_resource_form_add_products_and_services;

/** @type {(inputs: Admin_Resource_Form_Add_Products_And_ServicesInputs) => LocalizedString} */
const ro_admin_resource_form_add_products_and_services = en_admin_resource_form_add_products_and_services;

/**
* | output |
* | --- |
* | "Add Products & Services »" |
*
* @param {Admin_Resource_Form_Add_Products_And_ServicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_add_products_and_services = /** @type {((inputs?: Admin_Resource_Form_Add_Products_And_ServicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Add_Products_And_ServicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_add_products_and_services(inputs)
	if (locale === "de") return de_admin_resource_form_add_products_and_services(inputs)
	if (locale === "es") return es_admin_resource_form_add_products_and_services(inputs)
	if (locale === "fr") return fr_admin_resource_form_add_products_and_services(inputs)
	if (locale === "it") return it_admin_resource_form_add_products_and_services(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_add_products_and_services(inputs)
	if (locale === "pl") return pl_admin_resource_form_add_products_and_services(inputs)
	if (locale === "hu") return hu_admin_resource_form_add_products_and_services(inputs)
	return ro_admin_resource_form_add_products_and_services(inputs)
});
export { admin_resource_form_add_products_and_services as "admin.resource_form.add_products_and_services" }